<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <form data-vv-scope="PartitionInscription" @submit.prevent="PartitionInscription_validate">
      <vx-card ref="filterCard" :title="$t('student_by_partition')" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
            <p > {{ $t('room') }} <b style="color: #ff6141">*</b> </p>
            <v-select 
              :options="salles"
              @search="getSalle" 
              :clearable="true" 
              label="libelle"
              v-model="input.salle"
              class="w-full" name="salle" v-validate="'required'"/>                
            <span class="text-danger">{{ errors.first('PartitionInscription.salle') }}</span>
          </div>
          <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
            <p> {{ $t('partition') }} <b style="color: #ff6141">*</b> </p>
            <v-select 
              :disabled="input.salle ? false : true"
              :options="partitions"
              @search="getPartition" 
              :clearable="true" 
              label="long_label"
              v-model="input.partition"
              class="w-full" name="partition" v-validate="'required'"/>                
            <span class="text-danger">{{ errors.first('PartitionInscription.partition') }}</span>
          </div>
        </div>
      </vx-card>

      <vx-card>
        <div class="export-table">
          <vs-table :data="inscriptions" v-model="selected" multiple search>

            <template slot="header">
              <vs-button :disabled="!inscriptions.length || !selected.length" class="mt-4" color="success" type="border" icon-pack="feather" icon="icon-save" @click="PartitionInscription_validate">{{ $t("Submit") }}</vs-button>
            
              Taille: {{ inscriptions.length }}
            </template>

            <template slot="thead">
              <vs-th>{{ $t("Registration_number") }}</vs-th>
              <vs-th>{{ $t("full_name") }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.eleve.matricule }}</vs-td>
                <vs-td>{{ tr.eleve.full_name }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </form>
  </div>
</template>

<script>
let base_self = ''
const input_tempon = {
  id: null, 
  libelle: '',
  anneeScolaire: '',
  partition: '',
  inscription: '',
  classe: '',
  coef: '',
  is_active: true
}

import { Validator } from 'vee-validate'

export default {
  components: { },
  data () {
    return {
      selected: [],
      label: ['eleve', 'full_name'],
      paramSalle: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true,
          classe__is_active: true,
          classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          classe__niveau__is_active: true
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' },
        juste: {
          id: '',
          libelle: '',
          classe: {
            niveau: {
              id: ''
            }
          }
        }
      },
      paramInscription: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: [],
          abandon: false,
          anneeScolaire__cloture: false,
          anneeScolaire__encours: true
        },
        orderby: ['eleve__full_name'],
        juste: {
          abandonAtente: '',
          id: '',
          eleve: {
            id: '',
            photo: { url: '' },
            matricule: '',
            full_name: '',
            dateEntree: '',
            naissance: '',
            sexe: {
              code: ''
            }
          },
          statutEleve: {
            id: '',
            libelle: ''
          },
          salle: {
            id: '',
            libelle: ''
          }
        }
      },
      paramPartition: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true
        },
        orderby: ['ordre']
      },
      salles: [],
      inscriptions: [],
      partitions: [],
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    input: {
      handler  () {
        console.log(' --------------------------------------------------------------------------------------------------------------------------- ')
        if (base_self.input1.salle !== base_self.input.salle) {
          if (!base_self.input.salle || base_self.input.salle === '') {
            delete base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id']
            delete base_self.paramPartition.filter['niveauTypePartition__niveau__id']

            delete base_self.paramInscription.filter['anneeScolaire__id']
            delete base_self.paramInscription.filter['salle__id']
            base_self.partitions = []
          } else if ((base_self.input1.salle && base_self.input1.salle.id !== base_self.input.salle.id) || (base_self.input.salle.id && !base_self.input1.salle)) {
            base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
            base_self.paramPartition.filter['niveauTypePartition__niveau__id'] = base_self.input.salle.classe.niveau.id

            base_self.paramInscription.filter['anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
            base_self.paramInscription.filter['salle__id'] = base_self.input.salle.id
            base_self.getPartitionSimple()
            base_self.getInscriptionSimple()
          }
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
        console.log(' *************************************************************************************************************************** ')
      },
      deep: true
    }
  },
  methods: {
    getOptionLabel (option) {
      if (typeof option === 'object') {
        const length = this.label.length
        let element = option
        for (let i = 0; i < length; i++) {
          if (!element.hasOwnProperty(this.label[i])) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
              ` exist in options object ${JSON.stringify(option)}.\n` +
              'https://vue-select.org/api/props.html#getoptionlabel'
            )
          }

          element = element[this.label[i]]
        }
          
        // return option['created_at']
        return element
      }
      return option
    },
    initPartitionForInput (partitions) {
      if (partitions.length === 1) {
        base_self.input.partition = JSON.parse(JSON.stringify(partitions[0]))
      } else {
        base_self.input.partition = ''
        window.getESM.error(base_self.$t('Please_activate_a_partition_before_continuing'))
      }
    },
    getPartitionSimple () {
      delete base_self.paramPartition.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))

          base_self.initPartitionForInput(response.data.data)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPartition (search, loading) {
      loading(true)
      base_self.paramPartition.filter['long_label__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))

          base_self.initPartitionForInput(response.data.data)
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getInscriptionSimple () {
      delete base_self.paramInscription.filter['employe__full_name__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getInscription (search, loading) {
      loading(true)
      base_self.paramInscription.filter['eleve__full_name__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getSalleSimple () {
      delete base_self.paramSalle.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, base_self.paramSalle)
        .then((response) => {
          base_self.salles = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      base_self.paramSalle.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, base_self.paramSalle)
        .then((response) => {
          base_self.salles = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    PartitionInscription_validate () {
      base_self.$validator.validateAll('PartitionInscription').then(result => {
        if (result) {
          base_self.submitData()
        }
      })
    },
    async submitData () {
      base_self.$vs.loading()
      const input = JSON.parse(JSON.stringify(this.selected))
      const length = input.length
      const array = []

      for (let i = 0; i < length; i++) {
        const inscription = JSON.parse(JSON.stringify(input[i]))
        const element = {}

        element.inscription = inscription.id
        element.partition = base_self.input.partition.id
        element.is_active = true

        const param = JSON.parse(JSON.stringify(base_self.$store.state.paramPartitionInscription))
        param.filter['partition__id'] = element.partition
        param.filter['inscription__id'] = element.inscription
        const response = await base_self.$http.post(`${base_self.$store.state.route_for_esm}PartitionInscription`, param)
          .catch((error) => { 
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })

        if (!response.data.data.length) {
          array.push(element)
        }
      }

      const data = {
        many: true,
        data: array
      }
      
      base_self.$http.post(`${base_self.$store.state.route_for_esm}PartitionInscription`, data)
        .then((response) => { 
          window.getESM.success(base_self.$t('The_student_by_partition_are_added_successfully'), response)
          base_self.$vs.loading.close()
          base_self.$router.push('/report_cards_management/student_by_partition/').catch(() => {})
        })
        .catch((error) => { 
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    initValues () {
      /* base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon)) */

      base_self.$validator.errors.clear() 
    }
  },
  created () {
    base_self = this

    base_self.initValues()
    base_self.getSalleSimple()

    ///////////////////////////
    const dict = {
      custom: {
        salle: {
          required: base_self.$t('The_room_is_required')
        },
        inscription: {
          required: base_self.$t('The_Student_is_required')
        },
        partition: {
          required: base_self.$t('The_partition_is_required')
        }
      }
    }
    Validator.localize('en', dict)
    //////////////////////////
  }
}

</script>
